import React, { Component } from 'react'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import * as Icon from 'react-feather'
import Header from 'components/layout/Partials/Header'
import { Helmet } from "react-helmet";

import Loading from 'components/common/Loading'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DataTable from 'react-data-table-component'
import { setDataTables } from 'redux/actions/dataTablesActions'
import { getUsers } from 'redux/actions/authActions'
import { Theme } from 'utils/Theme'
import { withStyles } from '@material-ui/styles'
import AdminLayout from 'components/layout/AdminLayout'
import TextFieldGroup from 'components/common/TextFieldGroup'
import Section from 'components/UI/Section'
import { Box } from '@material-ui/core'
import TableActions from './Partials/TableActions'
const styles = Theme()

class Users extends Component {
  constructor(prop) {
    super(prop)
    this.state = {
      users: null,
      loading: false,
      search_input: '',
      errors: {},
    }
    
    this.columns = [
      {
        name: 'Name',
        selector: 'name',
        sortable: true,
      },
      {
        name: 'Qlik User Directory',
        selector: 'directory',
        sortable: true,
      },
      {
        name: 'Qlik User Id',
        selector: 'qsId',
        sortable: true,
      },
      {
        name: 'email',
        selector: 'email',
        sortable: true,
      },
      {
        name: 'Actions',
        sortable: false,
        minWidth: 320,
                cell: ({ _id }) => <TableActions id={_id} />,
      },
    ]
  }

  updateTablePage = (page, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows: tables[tableName] ? tables[tableName].totalRows : 20,
    }

    this.props.setDataTables(tables)
  }

  updateTableRows = (page, rows, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows,
    }
    this.props.setDataTables(tables)
  }

  getUsers = () => {
    axios
      .get('/api/users')
      .then(users => {
        this.setState({ users: users.data })
      })
      .catch(err => {
        this.setState({ errors: err })
      })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { users, search_input } = prevState

    if (nextProps.auth && search_input === '') {
      const auth = nextProps.auth
      if (auth.users) {
        users = auth.users
      }
    }

    return { users }
  }

  componentDidMount() {
    this.props.getUsers()
  }


  onChange = (event) => {
    const search_input = event.target.value

    this.setState({ [event.target.name]: event.target.value })

    const users = this.props.auth.users

    let updatedList = users.filter(function (item) {
      return (
        item.email.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.qsId.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.directory.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.name.toLowerCase().search(search_input.toLowerCase()) !== -1
      )
    })

    this.setState({ users: updatedList })
  }

  render() {
    const { users, loading, search_input } = this.state
    const { classes } = this.props

    return (
      <AdminLayout>
        <Helmet>
          <title>Users</title>
        </Helmet>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Users </h2>
          </Header>
          <div className="u-m-xsmall">
            {loading && (
              <div className="u-text-center u-m-auto">
                <Loading />
              </div>
            )}

            {!loading && (
              <Section>
                <Box className="u-ph-small u-pv-large u-mb-large full_height">
                  <div className=" o-line">
                    <h3 className={`${classes.colorPrimary} u-text-capitalize u-pt-zero u-mt-zero u-pb-small`}>
                      Users
                    </h3>
                    <button
                      onClick={() => this.props.history.push('/settings/users/create')}
                      className={`c-btn ${classes.buttonPrimary}`}
                    >
                      Create User
                    </button>
                  </div>
                  <div className={' o-line '}>
                    <TextFieldGroup
                      label={'User Search'}
                      onChange={this.onChange}
                      name={'search_input'}
                      value={search_input}
                      placeholder={'Name | Directory | Qlik ID | Email'}
                    />
                  </div>
                  <div className="c-table-responsive@wide">
                    <DataTable
                      title=""
                      columns={this.columns}
                      className={'c-table'}
                      keyField={'_id'}
                      data={users || []}
                      noHeader={true}
                      pagination
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                      paginationPerPage={20}
                      onChangePage={page => {
                        this.updateTablePage(page, 'users')
                      }}
                      onChangeRowsPerPage={(rows, page) => {
                        this.updateTableRows(page, rows, 'users')
                      }}
                      defaultSortField="name"
                    />
                  </div>
                </Box>
              </Section>
            )}
          </div>
        </div>
      </AdminLayout>
    )
  }
}

Users.propTypes = {
  auth: PropTypes.object.isRequired,
  setDataTables: PropTypes.func,
  dataTables: PropTypes.object,
  getUsers: PropTypes.func,
  classes: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  dataTables: state.dataTables,
})
export default connect(mapStateToProps, { getUsers, setDataTables })(withRouter(withStyles(styles)(Users)))
